import * as api from '../../constants/api';
import callApi from '../http';

const appVersion = async (body) => await callApi(api.APP_VERSION, body);

export { appVersion };
